export const TITLE_BROWSER_TRANSLATIONS = {
    EVENTS: "titleBrowser.events",
    TICKET_LOOKUP: "titleBrowser.ticketLookup"
}